"use client";

import * as React from "react";
import { TrendingUp } from "lucide-react";
import {
  Label,
  Pie,
  PieChart,
  Bar,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Cell,
  LabelList,
} from "recharts";
import formatToIndianCurrency from "../../utils/formatCurrency";

import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "../../components/ui/chart";

export const description =
  "A donut chart representing the PNL of Nifty and BankNifty";

export function DonutChart({ totalPnl, niftyPnl, bankniftyPnl, stocksPnl }) {
  // const [totalPnl, setTotalPnl] = React.useState(0);
  console.log("get data -----", niftyPnl, bankniftyPnl);

  // const chartData = [
  //   {
  //     index: "nifty",
  //     nifty: niftyPnl,
  //     banknifty: bankniftyPnl,
  //     stock: stocksPnl,
  //   },
  // ];

  const chartData = [
    { index: "nifty", pnl: niftyPnl, fill: "hsl(var(--chart-1))" },
    { index: "banknifty", pnl: bankniftyPnl, fill: "hsl(var(--chart-2))" },
    { index: "stocks", pnl: stocksPnl, fill: "hsl(var(--chart-3))" },
  ];

  const chartConfig = {
    pnl: {
      label: "Total PNL",
    },
  };

  const monthNow = new Date().toLocaleString('default', { month: 'short' });

  return (
    <Card className="flex flex-col">
      <CardHeader className="items-center pb-0">
        <CardTitle>PNL Chart (Index Wise) </CardTitle>
        <CardDescription>Jan 2023 - {monthNow} 2024</CardDescription>
      </CardHeader>
      <CardContent className="flex-1 pb-0">
        <ChartContainer config={chartConfig} className=" w-[400px] h-[350px] ">
          {/* <PieChart>
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent hideLabel />}
            />
            <Pie
              data={chartData}
              dataKey="pnl"
              nameKey="index"
              innerRadius={80}
              strokeWidth={2}
            >
              <Label
              className="w-[180px]"
                content={({ viewBox }) => {
                  if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                    return (
                      <text
                        x={viewBox.cx}
                        y={viewBox.cy}
                        textAnchor="middle"
                        dominantBaseline="middle"
                      >
                        <tspan
                          x={viewBox.cx}
                          y={viewBox.cy}
                          className={`fill-foreground text-[18px] font-bold
                            
                            }`}
                        >
                          {formatToIndianCurrency(totalPnl)}
                        </tspan>
                        <tspan
                          x={viewBox.cx}
                          y={(viewBox.cy || 0) + 24}
                          className="fill-muted-foreground"
                        >
                          Total PNL
                        </tspan>
                      </text>
                    );
                  }
                }}
              />
            </Pie>
          </PieChart> */}

          <BarChart accessibilityLayer data={chartData} className="scale-[0.95]">
            <CartesianGrid vertical={false} />
            <YAxis
                tickLine={false}
                axisLine={false}
                tickMargin={0}
                
                tickCount={7}
                // domain={["dataMin-100000", "dataMax+100000"]}
              
              />
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent hideLabel hideIndicator />}
            />
            <Bar dataKey="pnl" className="bg-white">
              <LabelList position="top" dataKey="index" className="text-white" fillOpacity={1} />
              {chartData.map((item) => (
                <Cell
                  key={item.index}
                  width={60}
                  className="text-white"
                  fill={
                    item.pnl > 0
                      ? "hsl(var(--chart-1))"
                      : "hsl(349.7 89.2% 60.2%)"
                  }
                />
              ))}
            </Bar>
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
